import type { NotifyPort } from '@/features/messages/domain/notify'
import type { SpawnMode, WorkItem, WorkItemPort } from '../domain/workflow'

const updateSpawnMode = async (
	port: WorkItemPort,
	id: string,
	spawnMode: SpawnMode,
	notify: NotifyPort,
): Promise<WorkItem | null> => {
	try {
		const updated = await port.updateSpawnMode(id, spawnMode)
		notify.success('workItem.derivedModeUpdated')
		return updated
	} catch {
		notify.error('workItem.updateDerivedModeFailed')
		return null
	}
}

export { updateSpawnMode }
